export const setScrollPosition = (position) => {
  // For browser compatibility (Firefox issue with document.body being depricated)
  document.body.scrollTop = document.documentElement.scrollTop = position || 0
}
